import React from 'react';
import ImageZoom from 'react-medium-image-zoom';

export const Img = ({ src, alt, ...props }) => {
  return (
    <>
      <ImageZoom image={{
        ...props,
        src,
        alt: alt || ' '
      }}
      />
    </>
  );
};
